module.exports = __webpack_public_path__ + "img/8.bc03a3b8.jpg";